import owlCarousel from 'owl.carousel';

$('.owl-carousel').owlCarousel({
  items: 1,

  loop: true,
  lazyLoad: true,

  margin: 0,

  autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: false,

  smartSpeed: 800,
  fluidSpeed: 800,
  autoplaySpeed:800,
  navSpeed: 800,
  dotsSpeed: 800,
  dragEndSpeed: 800,

  mouseDrag: true,
  touchDrag: true,
  pullDrag: false,
});




// WEBPACK FOOTER //
// ./app/blocks/slider/slider.js